import { createContext, useContext, type ReactNode } from 'react';
import { useObservable } from '@cdn/state';
import type { Theme } from './theme';

const Context = createContext<Theme | undefined>(undefined);

export function ThemeProvider({ theme, children }: { theme: Theme; children: ReactNode }) {
	return <Context.Provider value={theme}>{children}</Context.Provider>;
}

export function useTheme(): Theme {
	const theme = useContext(Context);
	if (!theme) throw new Error('useTheme needs a ThemeProvider');
	return useObservable(theme);
}
